import { eventBus } from '@/infra/event-bus/EventBus';

export type NotificationSeverity = 'info' | 'warn' | 'error';

export interface NotifyPayload {
  key: string;
  severity?: NotificationSeverity;
  params?: Record<string, string>;
}

/**
 * Stub do NotificationService. Emite no EventBus; React subscreve em U3 para mostrar toast.
 */
export function notify(payload: NotifyPayload): void {
  eventBus.emit('notification.show', payload);
}
